export const helpers = {
  'Invalid phone': 'Teléfono no válido',
  'Please, inform a valid email':
    'Por favor, ingrese un correo electrónico válido',
  'This email is already registered':
    'Este correo electrónico ya está registrado',
};
